import { apiClient } from '../../services/apiClient';
import type {
  CreatePaymentIntentRequest,
  CreatePaymentIntentResponse,
  PaymentHistory,
  PaymentHistoryResponse,
} from './types';

/**
 * Stripe Payment Intentを作成
 */
export async function createPaymentIntent(
  data: CreatePaymentIntentRequest
): Promise<CreatePaymentIntentResponse> {
  const response = await apiClient.post<CreatePaymentIntentResponse>(
    '/payments/create-payment-intent',
    data
  );
  return response.data;
}

/**
 * 決済履歴を取得
 */
export async function getPaymentHistory(params?: {
  status?: 'succeeded' | 'failed' | 'pending';
  limit?: number;
}): Promise<PaymentHistory[]> {
  const response = await apiClient.get<PaymentHistoryResponse>('/payments/history', {
    params,
  });
  return response.data;
}
